import { useContext, useDebugValue, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import PlateformeUtilitiesContext from '../Contexts/PlateformeUtilitiesProvider';

const useUtilities = () =>{
    // ? this is just a simple example of a custom hook with contextAPI
    // -----
    const { sideBarOpen, showErrors,openSnackBar,setSnackBarMessage, setIsSnackBarError , setOpenSnackBar} = useContext(PlateformeUtilitiesContext);
    const {i18n}=useTranslation();
    useDebugValue(sideBarOpen, sideBarOpen => sideBarOpen ? ' Side bar Opened' : 'Side bar Closed');
    // -----
    useEffect(() => {
        // setShowErrors(false);
        // setOpenSnackBar(false);
        if(showErrors == true){
            setSnackBarMessage(i18n.t('Veuillez compléter les champs obligatoires manquants'));
            setIsSnackBarError(true);
            setOpenSnackBar(true);
        }
    }, [showErrors, openSnackBar]);
    return useContext(PlateformeUtilitiesContext);
};

export default useUtilities;